import React, { useState, useEffect } from 'react';
import { badgeService } from '../api/services';
import './CustomBadgesSection.css';

// 顯示某使用者已獲得的「自訂榮譽徽章」（手動頒發型，與計算型成就徽章獨立）。
// 沒有任何榮譽徽章時整區隱藏，避免個人頁出現空區塊。
const CustomBadgesSection = ({ userId }) => {
  const [badges, setBadges] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!userId) return;
    badgeService.getUserBadges(userId)
      .then((res) => setBadges(res.data || []))
      .catch(() => setBadges([])) // 榮譽徽章為加分資訊，載入失敗時靜默隱藏
      .finally(() => setLoaded(true));
  }, [userId]);

  if (!loaded || badges.length === 0) return null;

  return (
    <div className="custom-badges-section">
      <div className="cbadge-header">
        <h3 className="cbadge-title">榮譽徽章</h3>
        <span className="cbadge-count">{badges.length} 枚</span>
      </div>
      <div className="cbadge-grid">
        {badges.map((b) => (
          <div key={b.id} className="cbadge-item" title={b.description || b.name}>
            <span className="cbadge-icon" style={{ background: b.color || '#f59e0b' }}>{b.icon || '🏆'}</span>
            <span className="cbadge-name">{b.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomBadgesSection;
